//@import dependencies
import React, {useState} from 'react'
import { useTranslation } from 'react-i18next'
// import {useSelector} from 'react-redux'
import { ButtonGroup, ToggleButton } from 'react-bootstrap'
//@end

//@import components
import NewsModule from 'app_components/modules/campus/news'

import SchedulingModule from 'app_components/modules/campus/academic/scheduling'
import QualificationsModule from 'app_components/modules/campus/academic/qualifications'
import GoalsModule from 'app_components/modules/campus/academic/goals'
import StatsModule from 'app_components/modules/campus/academic/stats'
// import CommentsModule from 'app_components/modules/campus/academic/comments'

// import ActivitySummaryModule from 'app_components/modules/campus/academic/activitySummary'
// import NotesAchievedModule from 'app_components/modules/campus/academic/notesAchieved'
// import ActivityDetailsModule from 'app_components/modules/campus/academic/activityDetails'
// import RelatedCoursesModule from 'app_components/modules/campus/academic/relatedCourses'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../teacherDashboardModule.scss'

// @ADD Component types
interface ITeacherDashboardModuleLayoutProps {}

const TeacherDashboardModuleLayout: React.FC<ITeacherDashboardModuleLayoutProps> = (props) => {

  // const user = useSelector((state: any) => state.auth?.user?.data ? state.auth.user.data : null)

  const { t } = useTranslation()

  const [menuSelected, setMenuSelected] = useState('1');
  const menus = [
    { name: t('modules.teacher_dashboard.sections.scheduling'), value: '1', status: 'enabled' },
    { name: t('modules.teacher_dashboard.sections.qualifications'), value: '2', status: 'enabled' },
    // { name: t('modules.teacher_dashboard.sections.goalds'), value: '3', status: 'disabled' },
    { name: t('modules.teacher_dashboard.sections.stats'), value: '4', status: 'enabled' },
    // { name: t('modules.teacher_dashboard.sections.comments'), value: '4' }
  ];

  return(
    <div className='teacher_dashboard-component'>
      <section className="teacher-dashboard-section-news">
        <NewsModule category='teacher' />
      </section>
      <section className="teacher-dashboard-main">
        <div className="row">
          <div className="col-12">
            <div className="teacher-sections">
              <ButtonGroup toggle>
                {menus.map((radio, idx) => (
                  <ToggleButton
                    key={idx}
                    type="radio"
                    variant="secondary"
                    name="radio"
                    value={radio.value}
                    checked={menuSelected === radio.value}
                    onChange={(e) => setMenuSelected(e.currentTarget.value)}
                    disabled={radio.status === 'disabled'}
                  >
                    {radio.name}
                  </ToggleButton>
                ))}
              </ButtonGroup>
            </div>

            {menuSelected === '1' && (<SchedulingModule role='teacher'/>)}
            {menuSelected === '2' && (<QualificationsModule />)}
            {/* {menuSelected === '3' && (<GoalsModule />)} */}
            {menuSelected === '4' && (<StatsModule />)}
            {/* {menuSelected === '4' && (<CommentsModule />)} */}
          </div>
        </div>
      </section>
      <section></section>
    </div>
  )
}

export default TeacherDashboardModuleLayout
